import request from '@apps-common/js-client/api/request';
import {ProductAccessStates} from '@account/constants/products';
import {PDA_ADMIN_V1_BASE_PATH as base} from '@account/config';

export const getProductAccesses = ({
  limit = 15,
  offset = 0,
  sort = 'title',
  descending = false,
  state = [ProductAccessStates.ACTIVE],
  customerAccountId,
  orgId,
  search,
} = {}) => {
  // Build search parameters based on search term
  const params = {
    limit,
    offset,
    sort: `${descending ? '-' : ''}${sort}`,
    state__in: state,
    customer_account_id: customerAccountId,
    organization_id: orgId,
  };

  // Handle search logic: if search term starts with "pl-" (case-insensitive),
  // use pl_number__icontains, otherwise use generic search
  if (search) {
    const trimmedSearch = search.trim().toLowerCase();
    if (trimmedSearch.startsWith('pl-')) {
      params.pl_number__icontains = search.trim(); // Use original casing for the actual search
    } else {
      params.search = search;
    }
  }

  return request.get(`${base}/product-access/`, {params}).then(res => res.data);
};

export const getProductAccess = productAccessId =>
  request
    .get(`${base}/product-access/${productAccessId}`)
    .then(res => res.data);

export const deactivateProductAccess = productAccessId =>
  request
    .delete(`${base}/product-access/${productAccessId}`)
    .then(res => res.data);

export const getProductAccessUsage = productAccessId =>
  request
    .get(`${base}/product-access/${productAccessId}/quota-usage`)
    .then(res => res.data);

export const getProductVariants = ({
  limit = 1000, // Large limit to get all variants in one call
  offset = 0,
  sort = 'title',
  descending = false,
} = {}) =>
  request
    .get(`${base}/products/`, {
      params: {
        limit,
        offset,
        sort: `${descending ? '-' : ''}${sort}`,
      },
    })
    .then(res => res.data);
